import React from "react";
import { Link } from "react-router-dom";
import AgreementCheckbox from "../AgreementCheckbox";
import styles from "./agreeTermsAndConditionsOfUseCheckbox.scss";
import { HelpingRoutes, PageRoute } from "../../../../../../../models";

const AgreeTermsAndConditionsOfUseCheckbox = ({ isChecked, onChange }) => (
  <AgreementCheckbox
    isChecked={isChecked}
    onChange={onChange}
    name="isAgreeTermsAndConditionsOfUse"
  >
    {`${"Prihvaćam"} `}
    <Link
      target="_blank"
      to={`${PageRoute.help}/${HelpingRoutes.termsOfUse}`}
      className={styles.link}
    >
      {"Uvjeti i pravila korištenja"}
    </Link>
  </AgreementCheckbox>
);

export default AgreeTermsAndConditionsOfUseCheckbox;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/AgreeTermsAndConditionsOfUseCheckbox/index.tsx